import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=09284b70&scoped=true"
import script from "./Compass.vue?vue&type=script&lang=js"
export * from "./Compass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09284b70",
  null
  
)

export default component.exports